var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/DependencyTree/Filters/InclusionFilter/FilterModel.ts";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import { combine, createApi, createEvent, createStore } from 'effector';
import { getMapFromPersist, isNotEmpty, storeMapToPersist } from '@gmini/utils';
export var FilterByInclusion;

(function (FilterByInclusion) {
  FilterByInclusion["Off"] = "Off";
  FilterByInclusion["Included"] = "Included";
  FilterByInclusion["NotIncluded"] = "NotIncluded";
})(FilterByInclusion || (FilterByInclusion = {}));

var INCLUSION_FILTER = 'INCLUSION_FILTER';
export var reset = createEvent('reset', {
  name: "reset",
  sid: "w7ocjf"
});
export var storageKey$ = createStore(null, {
  name: "storageKey$",
  sid: "-3w4c7w"
}).reset(reset);

var _createApi = createApi({
  ɔ: [storageKey$, {
    setStorageKey: function setStorageKey(_, payload) {
      return payload;
    }
  }],
  config: {
    sid: "-srjuop"
  }
}),
    setStorageKey = _createApi.setStorageKey;

export { setStorageKey };
var restoreState = setStorageKey.map(function (key) {
  return key ? getMapFromPersist(INCLUSION_FILTER)[key] || null : null;
}).filter({
  fn: isNotEmpty
});
export var byInclusion$ = createStore(FilterByInclusion.Off, {
  name: "byInclusion$",
  sid: "-hn2454"
}).on(restoreState, function (_, value) {
  return value;
}).reset(reset);
combine({
  ɔ: [storageKey$, byInclusion$, function (key, value) {
    return key ? {
      key: key,
      value: value
    } : null;
  }],
  config: {
    sid: "p81pvl"
  }
}).watch(function (entry) {
  var fromPersist = getMapFromPersist(INCLUSION_FILTER);

  if (entry) {
    storeMapToPersist(INCLUSION_FILTER, _objectSpread(_objectSpread({}, fromPersist), {}, _defineProperty({}, entry.key, entry.value)));
  }
});
export var byInclusion = createApi({
  ɔ: [byInclusion$, {
    set: function set(_, value) {
      return value;
    },
    takenOn: function takenOn() {
      return FilterByInclusion.Included;
    },
    notTakenOn: function notTakenOn() {
      return FilterByInclusion.NotIncluded;
    },
    off: function off() {
      return FilterByInclusion.Off;
    }
  }],
  config: {
    sid: "g7q84j"
  }
});
export var applied$ = byInclusion$.map(function (byInclusion) {
  return byInclusion === FilterByInclusion.Included || byInclusion === FilterByInclusion.NotIncluded;
});